import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

const locationResultDefaultPropClasses = {
  wrapper: 'fw-medium pv3 ph3',
  icon: 'pv2 ph2'
};
/** @param {any} props */
export default function LocationResult({
  classes = locationResultDefaultPropClasses,
  iconSize = '20px',
  place,
  onClick
}) {
  return (
    <a
      href="#"
      className={classnames(
        'LocationResult flex items-center gap-12 font-14 lh-title br3',
        classes.wrapper
      )}
      onClick={e => {
        e.preventDefault();
        onClick(place);
      }}
    >
      <span
        className={classnames('db secondary bg-gray-200 br3', classes.icon)}
      >
        <Icon name="fetch-location" width={iconSize} height={iconSize} />
      </span>
      {place.name}
    </a>
  );
}

LocationResult.propTypes = {
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    icon: PropTypes.string
  }),
  iconSize: PropTypes.string,
  place: PropTypes.shape({
    name: PropTypes.string.isRequired,
    getCoordinates: PropTypes.func.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
